// v2/components/CartSummary.js — sepet ozet paneli (sticky)
import React, { useState, useEffect, useRef } from 'react';
import { Tag, ArrowRight, StickyNote, TrendingDown, Loader2 } from 'lucide-react';
import { formatTRY, formatNumber, formatPercent } from '../utils/format';
import styles from './CartSummary.module.css';

/** Degisimde sayarak gecen deger */
function useCountUp(target, duration = 420) {
  const [value, setValue] = useState(target);
  const raf = useRef(null);
  const from = useRef(target);

  useEffect(() => {
    const reduce = typeof window !== 'undefined'
      && typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !Number.isFinite(target)) { setValue(target); from.current = target; return undefined; }

    const start = from.current;
    const delta = target - start;
    if (delta === 0) return undefined;

    const t0 = (typeof performance !== 'undefined' ? performance.now() : Date.now());
    const tick = (now) => {
      const pr = Math.min((now - t0) / duration, 1);
      setValue(start + delta * (1 - Math.pow(1 - pr, 3)));
      if (pr < 1) raf.current = requestAnimationFrame(tick);
      else from.current = target;
    };
    raf.current = requestAnimationFrame(tick);
    return () => { if (raf.current) cancelAnimationFrame(raf.current); };
  }, [target, duration]);

  return value;
}

export default function CartSummary({
  totals, eurRate = 0, note = '', onNoteChange = () => {},
  onCheckout = () => {}, disabled = false, loading = false,
}) {
  const grand = useCountUp(totals.grand);
  const save = useCountUp(totals.discount);
  const eur = (v) => (eurRate > 0 ? `${formatNumber(v / eurRate, 2)} €` : null);

  return (
    <aside className={styles.panel} aria-label="Sipariş özeti">
      <h2 className={styles.title}>Sipariş Özeti</h2>

      <div className={styles.rows}>
        <div className={styles.row}>
          <span>Brüt Toplam</span>
          <span className={styles.strike}>{formatTRY(totals.gross)}</span>
        </div>
        <div className={`${styles.row} ${styles.rowDiscount}`}>
          <span><Tag size={13} /> Toplam İndirim ({formatPercent(totals.discountPct)})</span>
          <span>−{formatTRY(totals.discount)}</span>
        </div>
        <div className={styles.row}>
          <span>Ara Toplam</span>
          <span>{formatTRY(totals.net)}</span>
        </div>
        <div className={styles.row}>
          <span>KDV (%{totals.vatRate})</span>
          <span>{formatTRY(totals.vat)}</span>
        </div>
      </div>

      <div className={styles.total}>
        <span className={styles.totalLabel}>Genel Toplam</span>
        <span className={styles.totalRight}>
          <span className={styles.totalVal}>{formatTRY(grand)}</span>
          {eurRate > 0 && <span className={styles.totalEur}>{eur(grand)}</span>}
        </span>
      </div>

      <div className={styles.saveBox}>
        <TrendingDown size={16} />
        <span className={styles.saveText}>Bu siparişte kazancınız</span>
        <span className={styles.saveVal}>{formatTRY(save)}</span>
      </div>

      <label className={styles.noteWrap}>
        <span className={styles.noteLabel}>
          <StickyNote size={12} /> Sipariş Notu
        </span>
        <textarea
          className={styles.note} value={note} rows={3}
          onChange={(e) => onNoteChange(e.target.value)}
          placeholder="Teslimat veya sipariş ile ilgili notunuz..."
          maxLength={500}
        />
        <span className={styles.noteCount}>{note.length}/500</span>
      </label>

      <button
        type="button" className={styles.btn}
        onClick={onCheckout} disabled={disabled || loading} aria-busy={loading}
      >
        {loading
          ? <><Loader2 size={17} className={styles.spin} /> Gönderiliyor…</>
          : <>Siparişi Tamamla <ArrowRight size={17} /></>}
      </button>
    </aside>
  );
}
